import { render, staticRenderFns } from "./StoreTop.vue?vue&type=template&id=b22a82a0&scoped=true"
import script from "./StoreTop.vue?vue&type=script&lang=js"
export * from "./StoreTop.vue?vue&type=script&lang=js"
import style0 from "./StoreTop.vue?vue&type=style&index=0&id=b22a82a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22a82a0",
  null
  
)

export default component.exports